import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeLab1 = ({autorizacUA, styles, handleClickSel11, handleClickSel12, handleClickSel13, handleClickSel14, handleClickSel15, 
                  handleClickSel16, handleClickSel17, handleClickSel18, handleClickSel19, handleClickSel20, handleClickSel21,
                  handleClickSel22, handleClickSel23, handleClickSel24, handleClickSel25, handleClickSel26, handleClickSel27, handleClickSel28}) => {
  const a1001 = autorizacUA.findIndex( autorizac => autorizac === "1001" );
  const a1005 = autorizacUA.findIndex( autorizac => autorizac === "1005" );
  const a1010 = autorizacUA.findIndex( autorizac => autorizac === "1010" );
  const a1015 = autorizacUA.findIndex( autorizac => autorizac === "1015" );
  const a1020 = autorizacUA.findIndex( autorizac => autorizac === "1020" );
  const a1025 = autorizacUA.findIndex( autorizac => autorizac === "1025" );
  const a1030 = autorizacUA.findIndex( autorizac => autorizac === "1030" );
  const a1035 = autorizacUA.findIndex( autorizac => autorizac === "1035" );
  const a1040 = autorizacUA.findIndex( autorizac => autorizac === "1040" );
  const a1045 = autorizacUA.findIndex( autorizac => autorizac === "1045" );
  const a1050 = autorizacUA.findIndex( autorizac => autorizac === "1050" );
  const a1055 = autorizacUA.findIndex( autorizac => autorizac === "1055" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large flask yellow icon"></i>
        LABORATORIO
      </button>

      {a1001!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel11}>
          <i className="large certificate red icon"></i>
          Pruebas
        </button>
      }      
      {a1005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel12}>
          <i className="large sliders red icon"></i>
          Valores de referencia
        </button>
      }
      {a1005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel20}>
          <i className="large sliders red icon"></i>
          Valores de referencia por mecanismo
        </button>
      }
      <Divider inverted />
      {a1010!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel13}>
          <i className="large edit outline red icon"></i>
          Crear informes
        </button>
      }    
      {a1050!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel24}>
            <i className="large searchengin red icon"></i>
            Enviar muestras al laboratorio
        </button>
      }
      {a1055!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
            <i className="large searchengin red icon"></i>
            Recibir muestras en laboratorio
        </button>
      }
      {a1015!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel14}>
          <i className="large angle double up red icon"></i>
          Cargar resultados
        </button>
      } 
      {a1055!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel26}>
            <i className="large searchengin red icon"></i>
            Enviar muestras al cliente
        </button>
      }
      {a1015!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
          <i className="large angle double up red icon"></i>
          Cargar imágenes de pruebas realizadas
        </button>
      } 
      {a1020!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel15}>
          <i className="large chart line red icon"></i>
          Generar reportes
        </button>
      } 
      {a1025!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel16}>
          <i className="large searchengin red icon"></i>
          Consultar Informes finalizados
        </button>
      }
      {a1025!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel19}>
          <i className="large file pdf outline red icon"></i>
          Consultar PDF de Informes finalizados
        </button>
      }
      {a1030!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
          <i className="large searchengin red icon"></i>
          Consultar Informes asociados a...
        </button>
      } 
      {a1040!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
          <i className="large searchengin red icon"></i>
          Consultar resultados de Laboratorio
        </button>
      }      
      {a1035!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
          <i className="large cubes red icon"></i>
          Informe gerencial
        </button>
      } 
      {a1035!==-1 && 
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
            <i className="large searchengin red icon"></i>
            Exportar a excel para indicadores
        </button>
      }
      {a1035!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel27}>
          <i className="chart bar red icon"></i>
          Tablero de control
        </button>
          }
    </div> 
  )
};

export default HomeLab1
